import styles from "./goals.module.css";

export interface ImplicitBindingProps {
  /** What the goal binds — a dataset, a collection. */
  label: string;
  /** The placeholder the binding is written as in the saved agent. */
  placeholder: string;
  /** When the value arrives, since it is never typed here. */
  hint: string;
}

/**
 * One binding a goal carries without anyone filling it in: stated, not
 * editable. A templated agent always runs against what was chosen at launch
 * time, so pinning an id into the agent would be a trap.
 */
export function ImplicitBinding({
  label,
  placeholder,
  hint,
}: ImplicitBindingProps) {
  return (
    <p className={styles.implicit}>
      <span className={styles.implicitLabel}>{label}</span>
      <code className={styles.implicitChip}>{placeholder}</code>
      <span className={styles.implicitHint}>{hint}</span>
    </p>
  );
}
